import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.min.css';
import 'swiper/css/pagination'; // 轮播图底面的小圆点
// import 'swiper/css/navigation' // 轮播图两边的左右箭头
import { Pagination, Autoplay } from 'swiper';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  components: {
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = swiper => {
      console.log('swiper', swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    let pagination = {
      el: '.swiper-pagination',
      type: 'bullets'
    };
    let autoplay = {
      autoplay: false,
      delay: 3000
    };
    let pageActive = ref(false);
    const modules = [Pagination, Autoplay];
    return {
      pageActive,
      modules,
      onSwiper,
      onSlideChange,
      pagination,
      autoplay
    };
  }
});